export default __webpack_public_path__ + "static/media/login.b2694a6d.svg";